/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/public/js/app.js` file.
 *
 * @package Bloom
 * @author    Tibor Paulsch <4tibor@gmail.com>
 * @copyright Copyright (c) 2018, Tibor Paulsch
 * @link      https:github.com/tiborp/tib2020
 * @license   http://www.gnu.org/licenses/old-licenses/gpl-2.0.html
 */

import ResponsiveMenu from './components/responsive-menu';

if (document.body.contains(document.getElementById('primary-menu'))) {
    // Setup a new menu
    const menu = new ResponsiveMenu('primary-menu', { animateToggle: true });
}

